import axiosInstance from "../../axios";

const payloadData = (response) => response.data;

const listFromResponse = (response) => {
  const payload = payloadData(response);

  return Array.isArray(payload) ? payload : [];
};

export const getStockDashboardGroups = async () => {
  const response = await axiosInstance.get("/store/stock_items/dashboard");
  return listFromResponse(response);
};

export const getStockAllGroups = async () => {
  const response = await axiosInstance.get("/store/stock_items/all_groups");
  return listFromResponse(response);
};

export const createStockItems = async ({ m_key, quantity }) => {
  const response = await axiosInstance.post("/store/stock_items", {
    m_key,
    quantity,
  });
  return listFromResponse(response);
};

export const getStockItems = async () => {
  const response = await axiosInstance.get("/store/stock_items");
  return listFromResponse(response);
};

export const updateStockItem = (id, status) =>
  axiosInstance.patch(`/store/stock_items/${id}`, { status });

export const getStockBatches = async ({ status } = {}) => {
  const response = await axiosInstance.get("/store/batches", {
    params: {
      item_type: "pm",
      ...(status ? { status } : {}),
    },
  });
  return listFromResponse(response);
};

export const createStockBatch = async ({ factory_id, stock_item_ids }) => {
  const response = await axiosInstance.post("/store/batches", {
    factory_id,
    stock_item_ids,
  });
  return payloadData(response);
};

export const getStockBatch = async (batchId) => {
  const response = await axiosInstance.get(`/store/batches/${batchId}`);
  return payloadData(response);
};

export const addStockItemsToBatch = async (batchId, { stock_item_ids }) => {
  const response = await axiosInstance.post(
    `/store/batches/${batchId}/add_parts`,
    { stock_item_ids }
  );
  return payloadData(response);
};

export const getOpsPartItems = async () => {
  const response = await axiosInstance.get("/store/part_items");
  return listFromResponse(response);
};

export const getOpsProjects = async () => {
  const response = await axiosInstance.get("/store/projects/ops");
  return listFromResponse(response);
};

export const updateOpsPartItem = (id, status, partItemId) => {
  const body = { status };

  if (partItemId != null) body.part_item_id = partItemId;

  return axiosInstance.patch(`/store/part_items/${id}`, body);
};

export const changeOpsPartItemsToJit = (partItemIds) =>
  axiosInstance.post("/store/part_items/change_to_jit", {
    part_item_ids: partItemIds,
  });

export const getOpsShipments = async () => {
  const response = await axiosInstance.get("/store/shipments/ops");
  return listFromResponse(response);
};

export const getLoadableShipments = async () => {
  const response = await axiosInstance.get("/store/shipments/loadable");
  return listFromResponse(response);
};

export const getShipmentPackets = async (shipmentId) => {
  const response = await axiosInstance.get(
    `/store/shipments/${shipmentId}/packets`
  );
  return listFromResponse(response);
};

export const getOpsShipmentParts = async (shipmentId) => {
  const response = await axiosInstance.get(
    `/store/shipments/${shipmentId}/parts`
  );
  return payloadData(response);
};

export const packIntoPackage = (packageId, { part_item_id }) =>
  axiosInstance.post(`/store/packages/${packageId}/pack`, {
    part_item_id,
  });

export const createShipmentPackage = (shipmentId, body) =>
  axiosInstance.post(`/store/shipments/${shipmentId}/packages`, body);

export const closePackage = (packageId) =>
  axiosInstance.post(`/store/packages/${packageId}/close`);

export const unpackPackage = (packageId) =>
  axiosInstance.post(`/store/packages/${packageId}/unpack`);

export const loadPackage = (packageId, { label }) =>
  axiosInstance.post(`/store/packages/${packageId}/load`, { label });

export const getStoreFactories = async () => {
  const response = await axiosInstance.get("/store/factories");
  return listFromResponse(response);
};

export const createStoreBatch = async ({ factory_id, part_item_ids }) => {
  const response = await axiosInstance.post("/store/batches", {
    factory_id,
    part_item_ids,
  });
  return payloadData(response);
};

export const getStoreBatches = async ({ status, item_type = "jit" } = {}) => {
  const response = await axiosInstance.get("/store/batches", {
    params: {
      item_type,
      ...(status ? { status } : {}),
    },
  });
  return listFromResponse(response);
};

export const getStoreBatch = async (batchId) => {
  const response = await axiosInstance.get(`/store/batches/${batchId}`);
  return payloadData(response);
};

export const addPartsToStoreBatch = async (batchId, { part_item_ids }) => {
  const response = await axiosInstance.post(
    `/store/batches/${batchId}/add_parts`,
    { part_item_ids }
  );
  return payloadData(response);
};

export const moveStoreBatchToProduction = async (batchId) => {
  const response = await axiosInstance.patch(
    `/store/batches/${batchId}/move_to_production`
  );
  return payloadData(response);
};

export const deleteStoreBatch = async (batchId) => {
  await axiosInstance.delete(`/store/batches/${batchId}`);
};

export const markStoreBatchReceived = async (batchId) => {
  const response = await axiosInstance.post(
    `/store/batches/${batchId}/mark_received`
  );
  return payloadData(response);
};

export const getCatalogProductsDashboard = async () => {
  const response = await axiosInstance.get("/store/catalog_products/dashboard");
  return listFromResponse(response);
};
